import { defineStore } from 'pinia'
import { optimizedDeepFreeze, safeFreeze, deduplicateStrings, compressObject, memoryStats } from './utils/memoryOptimizer.js'

export const useCatalogsStore = defineStore('catalogs', {
  state: () => ({
    adp_light: [],
    adp_radio: [],
    adp_tide: [],
    enp: [],
    countries: [],
    products: [],
    links: {},
    items: [],
    multiitems: {},
    chartsfeatures: undefined,
  }),
  getters: {
    getCatalogLength: state => state.products.length,
    getCountries: state => state.countries,
    getProducts: state => state.products,
    getMiltiItems: state => state.multiitems,
    getLinks: state => state.links,
    getItems: state => state.items,
    getItemsById: state => {
      return id => {
        return state.items.find(chart => chart.id === id)
      }
    },
    isComplexProduct: state => {
      return id => {
        const product = state.products.find(product => product.id === id)
        return product && product.productCellList && product.productCellList.productCells && product.productCellList.productCells.length > 1
      }
    },
    getChartsFeatures: state => state.chartsfeatures,
    getProductsCount: state => state.products.length,
    getENP: state => state.enp,
    getADP1: state => state.adp_light,
    getADP2: state => state.adp_radio,
    getADP3: state => state.adp_tide,

    // getADP: (state) => Object.freeze([...state.adp_light, ...state.adp_radio, ...state.adp_tide]),

    // Статистика использования памяти
    getMemoryStats: () => memoryStats,
  },
  actions: {
    addENP(val) {
      // Оптимизированная обработка для больших каталогов
      const processed = this._processLargeData(val.productTypes[0].productList)
      this.enp = optimizedDeepFreeze(processed)
    },
    addADP1(val) {
      const processed = this._processLargeData(val.productTypes[0].productList)
      this.adp_radio = optimizedDeepFreeze(processed)
    },
    addADP2(val) {
      const processed = this._processLargeData(val.productTypes[0].productList)
      this.adp_tide = optimizedDeepFreeze(processed)
    },
    addADP3(val) {
      const processed = this._processLargeData(val.productTypes[0].productList)
      this.adp_light = optimizedDeepFreeze(processed)
    },
    addCountries(val) {
      const processed = this._processLargeData(val)
      this.countries = optimizedDeepFreeze(processed)
    },
    addProducts(val) {
      // Для очень больших каталогов продуктов (5MB+) используем безопасную заморозку
      const processed = this._processLargeData(val)
      this.products = safeFreeze(processed)
    },
    addMultiItems(val) {
      const processed = this._processLargeData(val)
      this.multiitems = optimizedDeepFreeze(processed)
    },
    addLinks(val) {
      const processed = this._processLargeData(val)
      this.links = optimizedDeepFreeze(processed)
    },
    addItems(val) {
      const processed = this._processLargeData(val)
      this.items = safeFreeze(processed)
    },
    addChartsFeatures(val) {
      const processed = this._processLargeData(val)
      this.chartsfeatures = optimizedDeepFreeze(processed)
    },

    // Оптимизированная обработка данных
    _processLargeData(data) {
      // 1. Сжимаем объект, удаляя null/undefined
      let processed = compressObject(data)

      // 2. Дедуплицируем строки для экономии памяти
      processed = deduplicateStrings(processed)

      return processed
    },

    // Утилиты для управления памятью
    clearMemoryCaches() {
      memoryStats.clearCaches()
    },

    getMemoryUsageStats() {
      return {
        frozenObjects: memoryStats.frozenObjectsCount(),
        stringCacheSize: memoryStats.stringCacheSize(),
        totalItems: this.items.length + this.products.length + this.countries.length,
      }
    },

    reset() {
      this.countries = []
      this.products = []
      this.links = {}
      this.items = []
      this.multiitems = {}
      this.adp_light = []
      this.adp_radio = []
      this.adp_tide = []
      this.enp = []
      this.chartsfeatures = undefined

      // Очищаем кэши при сбросе
      this.clearMemoryCaches()
    },
  },
  persist: false,
})
